const seoServicesData = [
  {
    title: "Technical SEO",
    description:
      "Fix crawlability, speed, and structured data issues to unlock indexation and improve rankings.",
    bullets: ["CWV", "Sitemaps", "Schema", "Robots"],
    minHeight: 400,
  },
  {
    title: "On‑Page",
    description:
      "Optimize content, metadata, and information architecture for relevance and intent coverage.",
    bullets: ["Content", "Meta", "IA", "Links"],
    minHeight: 400,
  },
  {
    title: "Off‑Page",
    description:
      "Earn high‑quality backlinks and authority via digital PR, outreach, and partnerships.",
    bullets: ["Backlinks", "PR", "Outreach", "Mentions"],
    minHeight: 400,
  },
  {
    title: "Local SEO",
    description:
      "Improve local visibility with optimized maps, citations, reviews, and consistent NAP data.",
    bullets: ["GMB", "Citations", "Reviews", "NAP"],
    minHeight: 400,
  },
  {
    title: "Analytics",
    description:
      "Implement robust tracking and reporting with GA4/GSC dashboards and actionable insights.",
    bullets: ["GA4", "GSC", "Dashboards", "Reports"],
    minHeight: 400,
  },
  {
    title: "Content Ops",
    description:
      "Run a scalable content program with editorial calendars, briefs, production workflows, and QA.",
    bullets: ["Calendar", "Briefs", "Production", "QA"],
    minHeight: 400,
  },
  {
    title: "International SEO",
    description:
      "Expand to new markets with hreflang, localization, geo‑targeting, and multilingual content ops.",
    bullets: ["Hreflang", "i18n", "Geo Targeting", "Locales"],
    minHeight: 400,
  },
  {
    title: "E‑commerce SEO",
    description:
      "Optimize categories and PDPs, manage filters/facets, and implement product schema for scale.",
    bullets: ["Schema PDP", "Filters", "Internal Links", "CWV"],
    minHeight: 400,
  },
  {
    title: "SEO Automation",
    description:
      "Leverage templates, feeds, and programmatic SEO to generate pages and capture long‑tail demand.",
    bullets: ["Programmatic", "Feeds", "Templates", "Dashboards"],
    minHeight: 400,
  },
];

export default seoServicesData;
